import _ from 'lodash/fp'
import { connect } from 'react-redux'
import { compose, withHandlers, withProps, onlyUpdateForKeys } from 'recompose'
import { actions, selectors } from '../../reducers'
import constants from '../../constants'

const toRGBAString = color =>
  `rgba(${color.r},${color.g},${color.b},${color.a})`

const mapStateToProps = state => ({
  selectedContent: selectors.create.selectedContent(state),
  selectedContentId: state.create.selectedContentId,
  selectedContentColor: state.create.selectedContentColor,
  selectingContentType: state.create.selectingContentType,
  contentIds: _.keys(state.collections.content),
  content: state.collections.content,
  defaultContentId: state.collections.defaultContentId,
  startDate: state.create.startDate,
  endDate: state.create.endDate,
  nav: state.create.nav,
})

const mapDispatchToProps = {
  selectContentType: actions.create.selectContentType,
  selectContentColor: actions.create.selectContentColor,
  fetch: actions.collections.fetch,
  stopListening: actions.collections.stopListening,
  selectContentId: actions.create.selectContentId,
  selectNextContentId: actions.create.selectNextContentId,
  selectPrevContentId: actions.create.selectPrevContentId,
  setEventDate: actions.create.setEventDate,
  pushOne: actions.collections.pushOne,
  setOne: actions.collections.setOne,
  setNav: actions.create.setNav,
}

const createProps = props => ({
  fetch: () => {
    props.fetch('content')
    props.fetch('defaultContentId')
  },
  selectedContent: props.content[props.selectedContentId] || {},
  selectedContentId:
    props.selectingContentType === constants.createNav.SELECT_CONTENT_TYPE_THEME
      ? props.selectedContentId
      : toRGBAString(props.selectedContentColor),
})

const handlers = {
  selectNextContentId: props => () =>
    props.selectNextContentId(props.contentIds),
  selectPrevContentId: props => () =>
    props.selectPrevContentId(props.contentIds),
  selectContentId: props => id => props.selectContentId(id),
  updateDefaultContentId: props => defaultContentId =>
    props.setOne({
      collectionName: 'defaultContentId',
      value: props.selectedContentId,
    }),
  scheduleEvent: props => () =>
    props.pushOne({
      collectionName: 'events',
      item: {
        contentId: props.selectedContentId,
        startDate: props.startDate,
        endDate: props.endDate,
      },
    }),
  setStartDate: props => date =>
    props.setEventDate({
      type: 'startDate',
      date: date.toDate().getTime(),
    }),
  setEndDate: props => date =>
    props.setEventDate({
      type: 'endDate',
      date: date.toDate().getTime(),
    }),
}

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withProps(createProps),
  withHandlers(handlers),
  onlyUpdateForKeys([
    'startDate',
    'endDate',
    'selectingContentType',
    'selectedContentId',
    'content',
    'nav',
    'defaultContentId',
  ]),
)



// WEBPACK FOOTER //
// ./src/components/create/enhance.js